// src/app/config/customer1.config.ts

import {CustomerConfig} from "../CustomerConfig";

// SCHWABACH Config
export const customer5Config: CustomerConfig = {
  icons: {
    favIcon: 'SW-Schwabach-Logo.svg',
    icon: 'SW-Schwabach-Logo.svg',
  },
  strings: {
    title: 'Parkticket online bezahlen | Stadtwerke Schwabach',
    footerText: "test",
    email: "stadtdienste@stadtwerke-schwabach.de",
    number: "09122/ 936-400",
    contactRef: "https://www.stadtwerke-schwabach.de/Footer-Navigation/Impressum/",
    dataProtectionRef: "https://www.stadtwerke-schwabach.de/Footer-Navigation/Datenschutz/",
    metaDescription: "Parkticket jetzt online bezahlen – einfach, sicher & ohne Registrierung über tiefgarage.schwabach.de. Kennzeichen eingeben, Zahlung abschließen & weiterfahren.",
  }
};
